import React from "react";
import { FormGroup, FormLabel } from "react-bootstrap";
import Switch from "components/Switch";
import SwitchCompact from "components/SwitchCompact";

const SwitchField = ({
	controlId,
	isOn,
	onToggle,
	label,
	className = "",
	labelClassName = "",
	compact = false,
	style,
	disabled = false,
}) => {
	const SwitchComponent = compact ? SwitchCompact : Switch;

	return (
		<FormGroup
			className={`switch-field ${className}`.trim()}
			controlId={controlId}
			style={style}
		>
			<SwitchComponent
				controlId={controlId}
				isOn={isOn}
				handleToggle={onToggle}
				disabled={disabled}
			/>
			<FormLabel className={`switch-field__label ${labelClassName}`.trim()}>
				{label}
			</FormLabel>
		</FormGroup>
	);
};

export default SwitchField;
